module.exports = __webpack_public_path__ + "img/0Q3B7166_WoodMatted_MockedUp.ee795d0d.jpg";